import {memo, type FC} from 'react';
import ReactDOM from 'react-dom';

import classNames from 'classnames';

import {TypographySize, useTypography} from '@time-webkit/all/hooks/typography';
import {Button, BUTTON_SIZE, BUTTON_VARIANT} from '@time-webkit/all/atoms/button';
import {ActionButton} from '@time-webkit/all/molecules/icon-button';

import {useNotificationsGuideData} from '../hooks/use_notifications_guide_data';

import {ArrowBack} from '@time-webkit/all/icons/arrow_back';

import styles from './style.module.css';

type Props = {
    onClose: () => void;
}

export const NotificationsPermissionGuide: FC<Props> = memo(({onClose: handleClose}) => {
    const {imageSrcs: [step1ImageSrc, step2ImageSrc], texts} = useNotificationsGuideData();
    const [buttonCls, titleCls, stepCls] = useTypography([
        {size: TypographySize.BodyM, noDefaultColor: true},
        {size: TypographySize.Heading5},
        {size: TypographySize.BodyL},
    ]);

    const content = (
        <div className={classNames(styles.outerWrapper, styles.flex)}>
            <div className={styles.header}>
                <ActionButton onPress={handleClose} className={styles.backButton}>
                    <ArrowBack width={16} height={16}/>
                    <span className={buttonCls}>{texts.back}</span>
                </ActionButton>
            </div>
            <div className={styles.content}>
                <h5 className={classNames(titleCls, styles.title)}>{texts.title}</h5>
                <div className={classNames(stepCls, styles.step)}>{texts.step1}</div>
                <div className={classNames(styles.imageWrapper, styles.flex)}>
                    <img src={step1ImageSrc} alt={texts.step1} />
                </div>
                <div className={classNames(stepCls, styles.step)}>{texts.step2}</div>
                <div className={classNames(styles.imageWrapper, styles.flex)}>
                    <img src={step2ImageSrc} alt={texts.step2} />
                </div>
                <Button
                    className={styles.actionButton}
                    size={BUTTON_SIZE.LARGE}
                    variant={BUTTON_VARIANT.OUTLINE}
                    onPress={handleClose}
                >
                    {texts.action}
                </Button>
            </div>
        </div>
    );

    return ReactDOM.createPortal(content, document.body);
});
